import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/context"
import moment from "moment-timezone"
import { apiUrl } from "../../config/delcare"
import UiSpinner from "../../components/ui_spinner"
import UiTooltip from "../../components/ui_tooltip"

const BrandAuthStatus = (props) => {

    let {
        fetchDataV2,
        neonUser,
        clientAuthList,
        getAgencyClients,
        getBrands,
        brandList,
        ww,
        allAdsProfileIds,
        toastInit,
        setToastContent,
        token
    } = useContext(AppContext)

    let [load, setLoad] = useState(false)
    let [lastUpdate, setLastUpdate] = useState(null)

    const refreshAll = async () => {
        let newList = clientAuthList.filter(x => !!x.brand).filter(x => !!x.brand['active?'])

        if (newList.length == 0) {
            setToastContent("No data profiles found to refresh.")
            toastInit.show()
            return
        }

        setLoad(true)

        try {
            let ids = newList.map(x => x.client_info_id).sort((a, b) => a - b)

            for (let i = 0; i < ids.length; i++) {
                await new Promise(resolve => {
                    setTimeout(() => {
                        resolve()
                        fetch(`${apiUrl}/amazon-all-refresh-token-v2?record_db=true&client_id=${ids[i]}&user_refresh=1`, {
                            method: "GET",
                            headers: (() => {
                                const myHeaders = new Headers()
                                myHeaders.append("Content-Type", "application/json")
                                myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
                                return myHeaders
                            })()
                        })
                    }, 150)
                })
            }

            let time = null
            if (ids.length > 0) {
                let query1 = "UPDATE_SELLER_VENDOR_4_BULK", params1 = [ids]
                time = await fetchDataV2(query1, params1, "/neon-market-v2")
            }

            if (time && time.length > 0) {
                setLastUpdate(time[0].user_refresh_utc)
            }

            await getLatestTime()
            await getBrands()
        }
        catch (err) {
            return
        }
        finally {
            setLoad(false)
        }
    }

    const getLatestTime = async () => {
        setLoad(true)
        if (!neonUser?.user?.agency_id) {
            setLoad(false)
            return
        }

        let query1 = "GET_LATEST_TIME", params1 = [neonUser?.user?.agency_id]
        let resp = await fetchDataV2(query1, params1, "/neon-market-v2")

        if (!resp || resp.length == 0 || !resp[0].max) {
            setLoad(false)
            return
        }

        setLastUpdate(resp[0].max)
        setLoad(false)
        return
    }

    useEffect(() => {
        if (!!neonUser.user_id) getLatestTime()
    }, [neonUser])


    // useEffect(() => {
    //     console.log("BRANDS LIST", brandList)
    // }, [brandList])

    return (
        <div style={{ maxWidth: 1800 }}>
            <div className={"container1 d-flex w-100 text-center py-3" + (ww < 600 ? " flex-column " : " justify-content-between")}>
                {props.type == 'brand' ?
                    !props.brandLoad ?
                        <>
                            {brandList.filter(x => x['active?'] && x.has_error).length > 0 ?
                                <div className="text-danger fw-semibold">
                                    {brandList.filter(x => !!x['active?'] && x.has_error).length} Account/Brand(s) have 1 or more accounts with authentication issues.
                                </div>
                                :
                                // clientAuthList.filter(x => !!x.brand && !x.status && !!x.brand["active?"]).length > 0 ?
                                //     <div className="text-danger fw-semibold">
                                //         {clientAuthList.filter(x => !!x.brand && !x.status && !!x.brand["active?"]).length} Account/Brand(s) have 1 or more accounts with authentication issues.
                                //     </div>
                                //     :
                                brandList.length == 0 ?
                                    <span className="text-secondary fw-semibold">No brands yet.</span>
                                    :
                                    <span className="text-success fw-semibold">All Account/Brands are Connected</span>
                            }
                        </>
                        :
                        <UiSpinner />
                    : props.type == 'market' ?
                        !props.marketLoad ?
                            <>
                                {props.marketplace_list.length == 0 ?
                                    <span className="text-secondary fw-semibold">No marketplace(s) yet.</span>
                                    :
                                    props.marketplace_list.map(x => x.ppc_profiles).flatMap(x => x).map(x => x.profile_type == 'dsp' ? x.advertiser_id : x.profileId).filter(x => !allAdsProfileIds.includes(x)).length > 0
                                        || brandList.filter(x => props.marketplace_list.map(x => x.brand.id).includes(x.id)).filter(x => x.has_error).length > 0 ?
                                        <div className="text-danger fw-semibold">
                                            Account/Brand(s) or ads profile(s) have 1 or more authentication issues.
                                        </div>
                                        :
                                        <span className="text-success fw-semibold">All Account/Brands are Connected</span>
                                }
                            </>
                            :
                            <UiSpinner />
                        : null
                }

                <div className={"d-flex gap-1 poppins px-1 justify-content-center"}>
                    {load ?
                        <UiSpinner />
                        :
                        <>
                            <small hidden={!lastUpdate} className="mb-0 text-secondary align-self-center">
                                Authentication Last Checked: {!!lastUpdate ? moment.tz(lastUpdate, "UTC").subtract(8, "hours").format("MMM. D hh:mm A") + "  PST" : null}
                            </small>

                            <i title="Refresh" onClick={() => refreshAll()} className="bi bi-arrow-clockwise h4 mb-0" style={{ cursor: "pointer" }} />

                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default BrandAuthStatus